import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { lpForm } from 'lp-form'
import {
  Field,
  propTypes as formPropTypes,
  formValueSelector,
} from 'redux-form'
import { Select, ButtonArea, Checkbox, SubmitButton } from 'lp-components'
import { map, startCase, lowerCase } from 'lodash'

const FORM_NAME = 'LearningHubNotificationsPreferencesForm'

const propTypes = {
  closePreferencesModal: PropTypes.func.isRequired,
  frequency: PropTypes.string.isRequired,
  ...formPropTypes,
}

const LEARNING_HUB_NOTIFICATION_OPTIONS = [
  {
    name: 'learningHubDiscussionReplyOrMention',
    label: 'Discussion Reply or Mention',
  },
  {
    name: 'learningHubCourseEnrollment',
    label: 'Course Enrollment',
  },
  {
    name: 'learningHubCourseCompletion',
    label: 'Course Completion',
  },
  {
    name: 'learningHubInactiveLearnerNudges',
    label: "Inactive Learner Nudges (if you haven't logged in for 30+ days)",
  },
  {
    name: 'learningHubFormComments',
    label: 'Form Comments',
  },
]

function LearningHubNotificationsPreferencesForm({
  handleSubmit,
  closePreferencesModal,
  frequency,
  submitting,
  change,
}) {
  const frequencyOptions = map(Types.EMAIL_FREQUENCY, (value, key) => ({
    key: startCase(lowerCase(key)),
    value,
  }))

  const clearLearningHubOptions = () => {
    LEARNING_HUB_NOTIFICATION_OPTIONS.forEach(({ name }) => change(name, false))
  }

  return (
    <div>
      <div>
        <h2>Email Notification Preferences</h2>
      </div>
      <form onSubmit={handleSubmit} noValidate>
        <Field
          name="emailFrequency"
          component={Select}
          options={frequencyOptions}
          onChange={() => {
            if (frequency === Types.EMAIL_FREQUENCY.NEVER) {
              clearLearningHubOptions()
            }
          }}
          required
        />
        {frequency !== Types.EMAIL_FREQUENCY.NEVER && (
          <div className="preferences-wrapper">
            <legend>Send Me Email Notifications For:</legend>
            <div className="checkbox-container">
              {LEARNING_HUB_NOTIFICATION_OPTIONS.map(({ name, label }) => (
                <Field
                  key={name}
                  name={name}
                  component={Checkbox}
                  label={label}
                />
              ))}
            </div>
          </div>
        )}

        <ButtonArea>
          <SubmitButton submitting={submitting}>Save</SubmitButton>
          <button
            type="button"
            className="button-grey-light"
            onClick={closePreferencesModal}
          >
            Cancel
          </button>
        </ButtonArea>
      </form>
    </div>
  )
}

LearningHubNotificationsPreferencesForm.propTypes = propTypes

const preferencesSelector = formValueSelector(FORM_NAME)

function mapStateToProps(state) {
  return {
    frequency: preferencesSelector(state, 'emailFrequency'),
  }
}

export default compose(
  lpForm({
    name: FORM_NAME,
    constraints: {
      emailFrequency: { presence: true },
    },
  }),
  connect(mapStateToProps)
)(LearningHubNotificationsPreferencesForm)
